import React, { Component } from 'react';
import { dAPI } from 'appSrc/api';
import { DLTextField } from 'appSrc/components/UI';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import AllContentTable from './Table';
import { DLModal } from 'appSrc/components/Shards';
import style from './styles/style.module.css';

class ContentSearchModal extends Component {
    state = {
        fetching: false,
        content: [],
        searchValue: '',
    }
    contentQueryObject = {
        page: 1,
        limit: 25,
        sort: 'title,id',
        search: undefined,
    }
    componentDidMount() {
        this.loadContent();
    }
    updateSearch = ( e, { value } ) => {
        this.setState( { searchValue: value } );
    }
    onSearchKeyDown = ( e ) => {
        if( e.keyCode == 13 ) {
            e.preventDefault();
            this.contentQueryObject.page = 1;
            this.contentQueryObject.search = this.state.searchValue || undefined;

            this.setState( ( prevState ) => {
                prevState.fetching = true;
                prevState.content = [];
                return prevState;
            } );
            this.loadContent();
        }
    }
    loadContent = () => {
        return dAPI.get( '/admin/content', this.contentQueryObject )
        .then( ( content ) => {
            this.contentQueryObject.page++;
            this.setState( ( prevState ) => {
                prevState.fetching = false;
                prevState.content = prevState.content.concat( content );
                return prevState;
            } );
            return content;
        } );
    }

    render() {
        const { fetching, content, searchValue } = this.state;

        return (
            <DLModal title='Content Search'
            className={ style.contentSearchModal }
            closeHandler={ this.props.closeModal }>
                <div>
                    <div className={ style.controls }>
                        <DLTextField className={ style.searchBar }
                        placeholder='Search'
                        value={ searchValue }
                        onChange={ this.updateSearch }
                        onKeyDown={ this.onSearchKeyDown }
                        noError />
                    </div>
                    <div>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <AllContentTable
                            content={ content }
                            markedContent={ this.props.existingContent }
                            loadMore={ this.loadContent }
                            onSubmit={ this.props.onSubmit }
                            elementHeight={ 90 } />
                        }
                    </div>
                </div>
            </DLModal>
        );
    }
}
ContentSearchModal.defaultProps = {
    onSubmit: () => {},
};


export default ContentSearchModal;
